/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { PastedItemsInfo } from '../../../../feature/src/lib/models/pasted-items-info';
import { Item } from 'libs/sysque/toolbelt/data-access/src/lib/domain/item';

@Injectable({
  providedIn: 'root',
})
export class SysQueCopyPasteService {
  //#region Duplicate Items List

  private duplicateItemListSubject: BehaviorSubject<PastedItemsInfo[]> = new BehaviorSubject<PastedItemsInfo[]>([]);
  public duplicateItemList$: Observable<PastedItemsInfo[]> = this.duplicateItemListSubject.asObservable();

  public setDuplicateItemsList(duplicateItems: PastedItemsInfo[]): void {
    this.duplicateItemListSubject.next([...duplicateItems]);
  }

  public getDuplicateItemsList(): PastedItemsInfo[] {
    return [ ...this.duplicateItemListSubject.getValue() ];
  }

  //#endregion

  //#region Copied Items Name

  private copiedItemsNameSubject: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
  public copiedItemsName$: Observable<string[]> = this.copiedItemsNameSubject.asObservable();

  public setCopiedItemsName(copiedItemsName: string[]): void {
    this.copiedItemsNameSubject.next([...copiedItemsName]);
  }

  public getCopiedItemsName(): string[] {
    return [ ...this.copiedItemsNameSubject.getValue() ];
  }

  //#endregion

  //#region Src Copied Items

  private copiedItemsListSubject: BehaviorSubject<Item[]> = new BehaviorSubject<Item[]>([]);
  public copiedItemsList$: Observable<Item[]> = this.copiedItemsListSubject.asObservable();

  public setCopiedItemsList(copiedItems: Item[]): void {
    this.copiedItemsListSubject.next([...copiedItems]);
  }

  public getCopiedItemsList(): Item[] {
    return [ ...this.copiedItemsListSubject.getValue() ];
  }

  //#endregion

   //#region unique Src Copied Items

   private copiedUniqueItemsListSubject: BehaviorSubject<PastedItemsInfo[]> = new BehaviorSubject<PastedItemsInfo[]>([]);
   public copiedUniqueItemsList$: Observable<PastedItemsInfo[]> = this.copiedUniqueItemsListSubject.asObservable();
 
   public setUniqueCopiedItemsList(copiedItems: PastedItemsInfo[]): void {
     this.copiedUniqueItemsListSubject.next([...copiedItems]);
   }
 
   public getUniqueCopiedItemsList(): PastedItemsInfo[] {
     return [ ...this.copiedUniqueItemsListSubject.getValue() ];
   }
 
   //#endregion
}
